import config from "../../config"
import RequestService from "../RequestService"

const createLaborType = (params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/labor_types`, { labor_type: params }, successCallback, failureCallback)
}

export default createLaborType;